module.exports = __webpack_public_path__ + "img/GloomhavenThumb.3a196a0e.png";